<template>
  <div class="import-view">
    <div class="mb-5">
      <SidebarToggleView />
      <span class="display-2" v-if="company == null">Verzeichnis anlegen</span>
      <span class="display-2" v-else-if="company">Verzeichnis für {{ company.name }} anlegen</span>
    </div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step v-if="from_template" :complete="e1 > 1" step="1">Vorlage</v-stepper-step>
        <v-stepper-step v-else :complete="e1 > 1" step="1">Datei Auswählen</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">Details</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">Fertig</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content v-if="from_template" step="1">
          <v-card class="mb-4" flat>
            <v-card-title class="headline">Verzeichnis-Vorlage</v-card-title>
            <v-container>
              <v-row>
                <v-col>
                  <v-list>
                    <v-list-item-group mandatory color="primary">
                      <v-list-item v-on:click="setTemplateId('minimal')">
                        <v-list-item-title>Vorlage - Minimal</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-on:click="setTemplateId('arzt')">
                        <v-list-item-title>Vorlage - Arzt</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-on:click="setTemplateId('verein')">
                        <v-list-item-title>Vorlage - Verein</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-on:click="setTemplateId('stb')">
                        <v-list-item-title>Vorlage - StB</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-on:click="setTemplateId('allgemein')">
                        <v-list-item-title>Vorlage - Allgemein</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-on:click="setTemplateId('import')">
                        <v-list-item-title>SODA-Datei</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
                <v-col>
                  <v-card v-if="!templateIsImport()" class="pa-2" outlined tile>
                    <v-card-title :disabled="!can_create_from_template(template_id)">
                      {{ template.name }}
                    </v-card-title>
                    <v-card-text :disabled="!can_create_from_template(template_id)">
                      {{ template.description }}<br><br>
                      Die Vorlage beinhaltet:
                      <div v-if="proc.numParsedWithoutErrors>0">
                        <ul>
                          <li>{{proc.numParsedWithoutErrors}} Verarbeitungsverfahren (Verfahren)</li>
                          <li>{{mset.numParsedWithoutErrors}} allgemeine technisch organisatorische Maßnahmen (TOMs)</li>
                        </ul>
                      </div>
                      <div v-else>
                        <!-- when vuetify version updated -->
                        <v-skeleton-loader type="list-item" class="mx-auto"></v-skeleton-loader>
                      </div>
                    </v-card-text>
                    <v-card-actions v-if="can_create_from_template(template_id)">
                      <v-btn
                        color="primary"
                        outlined
                        @click="onNext()"
                        :disabled="!can_create_from_template(template_id)"
                        >Auswählen
                      </v-btn>
                    </v-card-actions>
                    <v-card-actions v-if="!can_create_from_template(template_id)">
                      <v-btn color="primary" outlined v-on:click="forwardToPurchase()">Vorlage freischalten </v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-card v-else class="mb-4" flat height="300px">
                    <v-card-title class="headline">SODA-Datei importieren</v-card-title>
                    <v-card-text
                      >Hier können Sie eine SODA-Datei mit Verfahren und allgemeinen TOMs hochladen.</v-card-text
                    >
                    <v-spacer></v-spacer>
                    <v-col cols="12" class="text-center text-sm-center text-md-center text-lg-center">
                      <v-text-field
                        label="Datei wählen"
                        @click="pickFile"
                        v-model="fileName"
                        prepend-icon="attach_file"
                      ></v-text-field>
                      <input type="file" style="display: none" ref="excel" @input="onFilePicked" />
                    </v-col>
                    <v-card-text v-if="parseExcelSuccess && (proc.parsed.length || mset.parsed.length)"
                      >Die SODA-Datei enthält {{ proc.parsed.length }} Verfahren und {{ mset.parsed.length }} allgemeine
                      TOMs.
                    </v-card-text>
                    <v-card-text v-else-if="parseExcelSuccess" class="error--text">
                      Die ausgewählte Datei ist keine SODA-Datei!
                    </v-card-text>
                    <v-card-actions>
                      <!--<v-btn text @click="loadTemplateSample()">Muster Laden</v-btn>-->
                      <v-btn color="primary" outlined text @click="onNext()" :disabled="!parseExcelSuccess || (!proc.parsed.length && !mset.parsed.length)"
                        >Weiter</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-btn text @click="cancel()">Abbrechen</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content v-else step="1">
          <v-card class="mb-4" flat height="300px">
            <v-card-title class="headline">SODA-Datei mit Verfahrensverzeichnis Auswählen</v-card-title>
            <v-card-text>Hier können Sie eine SODA-Datei mit Verfahren und allgemeinen TOMs hochladen.</v-card-text>
            <v-spacer></v-spacer>
            <v-col cols="12" class="text-center text-sm-center text-md-center text-lg-center">
              <v-text-field
                label="Datei wählen"
                @click="pickFile"
                v-model="fileName"
                prepend-icon="attach_file"
              ></v-text-field>
              <input type="file" style="display: none" ref="excel" @input="onFilePicked" />
            </v-col>
            <v-card-text v-if="parseExcelSuccess"
              >Die SODA-Datei enthält {{ proc.parsed.length }} Verfahren und {{ mset.parsed.length }} allgemeine
              TOMs.</v-card-text
            >
            <v-card-actions>
              <!--<v-btn text @click="loadTemplateSample()">Muster Laden</v-btn>-->
              <v-btn text @click="cancel()">Abbrechen</v-btn>
              <v-btn text @click="onNext()" :disabled="!parseExcelSuccess">Zur Übersicht</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-card class="mb-4">
            <v-card-title class="headline">Übersicht</v-card-title>
            <div v-if="parseExcelSuccess">
              <v-card-text>
                Folgende Verfahren, TOMs, Verknüpfungen und Einzelmaßnahmen wurden erkannt und können angelegt werden:
              </v-card-text>
              <v-spacer></v-spacer>
              <v-treeview v-model="importSelection" :items="parseResults" open-on-click>
                <template v-slot:append="{ item, open }">
                  <v-tooltip v-if="item.error" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="red">error</v-icon>
                    </template>
                    <span>{{ item.error }}</span>
                  </v-tooltip>
                  <v-tooltip v-else-if="item.warning" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="yellow">warning</v-icon>
                    </template>
                    <span>{{ item.warning }}</span>
                  </v-tooltip>
                  <v-icon v-else-if="item.ok" color="green">check_circle</v-icon>
                </template>
              </v-treeview>
              <v-card-text class="mt-2">
                <p>
                  Sollen die
                  {{
                    proc.numParsedWithoutErrors +
                      mset.numParsedWithoutErrors +
                      proc_mset.numParsedWithoutErrors +
                      mset_measure.numParsedWithoutErrors +
                      proc_measure.numParsedWithoutErrors
                  }}
                  Datensätze jetzt angelegt werden?
                </p>
              </v-card-text>
            </div>
            <div v-else>Es konnten keine Einträge gelesen werden.</div>
            <v-card-actions>
              <v-btn text @click="e1 = 1">Zurück</v-btn>
              <v-btn
                color="primary"
                outlined
                @click="upload()"
                v-if="proc.numParsedWithoutErrors + mset.numParsedWithoutErrors > 0"
                >Jetzt Anlegen</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-card class="mb-4">
            <v-card-text>
              <v-progress-linear
                class="mb-4"
                :value="
                  (100 *
                    (proc.numUploadedWithoutErrors +
                      mset.numUploadedWithoutErrors +
                      proc_mset.numUploadedWithoutErrors +
                      mset_measure.numUploadedWithoutErrors +
                      proc_measure.numUploadedWithoutErrors)) /
                    (proc.prepared.length +
                      mset.prepared.length +
                      proc_mset.prepared.length +
                      mset_measure.prepared.length +
                      proc_measure.prepared.length)
                "
              ></v-progress-linear>

              <v-alert :value="proc.uploadSuccess" type="success" transition="scale-transition"
                >{{ proc.numParsedWithoutErrors }} Verfahren erfolgreich angelegt.</v-alert
              >
              <v-alert :value="proc.uploadPartialFailure" type="warning" transition="scale-transition">
                {{ proc.numUploadedWithoutErrors }} von {{ proc.numParsedWithoutErrors }} Verfahren erfolgreich
                angelegt. Bei {{ proc.numUploadErrors }} Verfahren gab es einen Fehler.
              </v-alert>
              <v-alert :value="proc.uploadTotalFailure" type="error" transition="scale-transition"
                >{{ proc.numParsedWithoutErrors }} Verfahren konnten nicht importiert werden.</v-alert
              >

              <v-alert :value="mset.uploadSuccess" type="success" transition="scale-transition"
                >{{ mset.numParsedWithoutErrors }} allgemeine TOMs erfolgreich angelegt.</v-alert
              >
              <v-alert :value="mset.uploadPartialFailure" type="warning" transition="scale-transition">
                {{ mset.numUploadedWithoutErrors }} von {{ mset.numParsedWithoutErrors }} allgemeine TOMs erfolgreich
                angelegt. Bei {{ mset.numUploadErrors }} TOMs gab es einen Fehler.
              </v-alert>
              <v-alert :value="mset.uploadTotalFailure" type="error" transition="scale-transition"
                >{{ mset.numParsedWithoutErrors }} allgemeine TOMs konnten nicht importiert werden.</v-alert
              >

              <v-alert :value="proc_mset.uploadSuccess" type="success" transition="scale-transition">
                {{ proc_mset.numParsedWithoutErrors }} Verknüpfungen zwischen Verfahren und TOMs erfolgreich
                hergestellt.
              </v-alert>
              <v-alert :value="proc_mset.uploadPartialFailure" type="warning" transition="scale-transition">
                {{ proc_mset.numUploadedWithoutErrors }} von {{ proc_mset.numParsedWithoutErrors }} Verknüpfungen
                zwischen Verfahren und TOMs hergestellt. Bei {{ proc_mset.numUploadErrors }} Verknüpfungen gab es einen
                Fehler.
              </v-alert>
              <v-alert :value="proc_mset.uploadTotalFailure" type="error" transition="scale-transition">
                {{ proc_mset.numParsedWithoutErrors }} Verknüpfungen zwischen Verfahren und TOMs konnten nicht
                hergestellt werden.
              </v-alert>

              <v-alert :value="proc_measure.uploadSuccess" type="success" transition="scale-transition"
                >{{ proc_measure.numParsedWithoutErrors }} To-Dos erfolgreich hinzugefügt.</v-alert
              >
              <v-alert :value="proc_measure.uploadPartialFailure" type="warning" transition="scale-transition">
                {{ proc_measure.numUploadedWithoutErrors }} von {{ proc_measure.numParsedWithoutErrors }} To-Dos
                erfolgreich geschrieben. Bei {{ mset_measure.numUploadErrors }} To-Dos gab es einen Fehler.
              </v-alert>
              <v-alert :value="proc_measure.uploadTotalFailure" type="error" transition="scale-transition"
                >{{ proc_measure.numParsedWithoutErrors }} To-Dos konnten nicht hinzugfügt werden.</v-alert
              >

              <v-alert :value="mset_measure.uploadSuccess" type="success" transition="scale-transition"
                >{{ mset_measure.numParsedWithoutErrors }} Einzelmaßnahmen erfolgreich hinzugefügt.</v-alert
              >
              <v-alert :value="mset_measure.uploadPartialFailure" type="warning" transition="scale-transition">
                {{ mset_measure.numUploadedWithoutErrors }} von
                {{ mset_measure.numParsedWithoutErrors }} Einzelmaßnahmen erfolgreich hinzugefügt. Bei
                {{ mset_measure.numUploadErrors }} gab es einen Fehler.
              </v-alert>
              <v-alert :value="mset_measure.uploadTotalFailure" type="error" transition="scale-transition"
                >{{ mset_measure.numParsedWithoutErrors }} Einzelmaßnahmen konnten nicht hinzugefügt werden.</v-alert
              >
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="cancelSuccess()" v-if="uploadSuccess">Fertig</v-btn>
              <v-btn @click="cancelFailed()" v-if="!uploadSuccess">Fertig</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import XLSX from "xlsx";
import SidebarToggleView from "./SidebarToggleView";

const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    processes (limit: 500){
        items {
            id
            seq_nr
            text_header
        }
    }
    measureSets (limit: 50){
        items {
            id
            seq_nr
            type
        }
    }
    createdAt
    updatedAt
    archived_at
  }
}
`;
import {
  createProcess,
  createMeasureSet,
  createProcessMeasureSet,
  createMeasureSetMeasure,
  createProcessMeasure,
} from "../graphql/mutations";

import load_specs from "../specs/specs_parser";

import { util } from "./lib/util";

function generate_fields_mapping(specfile) {
  const specs = load_specs(specfile);
  var fields_mapping = {};
  specs.fields.map((e) => {
    fields_mapping[e.name] = {
      optional: e.required === undefined ? true : !e.required,
      allowed_names: [e.export_label === undefined ? e.label : e.export_label].concat(
        e.old_name === undefined ? [] : [e.old_name]
      ),
      json_list: e.multiple || (e.relationship && e.relationship === "n:m") ? true : false,
      decode_dict: e.decode_dict,
      encode_dict: e.decode_dict
        ? Object.fromEntries(Object.entries(e.decode_dict).map(([k, v]) => [v, k]))
        : undefined,
      default_value: e.default,
    };
  });
  fields_mapping;
  return fields_mapping;
}

const company_fields_mapping = generate_fields_mapping("company.yml");
const process_fields_mapping = generate_fields_mapping("process.yml");
const measureset_fields_mapping = generate_fields_mapping("measureSet.yml");
const msetmeasure_fields_mapping = generate_fields_mapping("measureSetMeasure.yml");
const procmeasure_fields_mapping = generate_fields_mapping("processMeasure.yml");

function parse_raw(raw_data, fields_mapping, name_field, entity_type) {
  var parsed = [];
  var parse_results = [];
  var parsed_without_errors = 0;
  var allowed_field_to_key = {};
  for (var key in fields_mapping) {
    fields_mapping[key].allowed_names.forEach((allowed) => {
      allowed_field_to_key[allowed] = key;
    });
  }
  raw_data.forEach((raw_entity) => {
    var entity = { warnings: [], errors: [] };
    for (var field in raw_entity) {
      if (!(field in allowed_field_to_key)) {
        entity.warnings.push("Warnung: Feld " + field + " konnte nicht zugeordnet werden.");
      } else {
        var key = allowed_field_to_key[field];

        if (fields_mapping[key].json_list) {
          entity[key] = JSON.stringify(
            raw_entity[field]
              .toString()
              .split(";")
              .map((e) => e.trim())
          );
        } else {
          var value = raw_entity[field];
          if (fields_mapping[key].encode_dict) {
            var encode_dict = fields_mapping[key].encode_dict;
            if (encode_dict[value]) {
              value = encode_dict[value];
            } else {
              var default_value = fields_mapping[key].default_value;
              entity.warnings.push(
                "Warnung: Feld " +
                  field +
                  " hat ungültigen Wert " +
                  value +
                  ". Setze Wert auf " +
                  fields_mapping[key].decode_dict[default_value] +
                  "."
              );
              value = default_value;
            }
          }
          entity[key] = value;
        }
        if ((entity[key] === null) | (entity[key].toString().trim() == "")) {
          if (!fields_mapping[key].optional) {
            entity.errors.push("Fehler: Pflichtfeld " + field + " hat leeren Inhalt.");
          }
        }
      }
    }
    for (var key in fields_mapping) {
      if (!(key in entity)) {
        if (!fields_mapping[key].optional) {
          entity.errors.push("Fehler: Pflichtfeld " + fields_mapping[key].allowed_names[0] + " fehlt.");
        }
      }
    }
    parsed.push(entity);
  });

  // generate parse_results: for per entity errors and warnings indication.
  var name_fields = typeof name_field === "string" ? [name_field] : name_field;
  parsed.forEach((entity, idx) => {
    parse_results.push({
      id: entity_type + "|" + name_fields.map((nf) => entity[nf]).join("-"),
      name: name_fields.map((nf) => entity[nf]).join(" "),
      error: entity.errors.length > 0 ? entity.errors.join("; ") + entity.warnings.join("; ") : undefined,
      warning: (entity.errors.length == 0) & (entity.warnings.length > 0) ? entity.warnings.join("; ") : undefined,
      ok: (entity.errors.length == 0) & (entity.warnings.length == 0) ? true : undefined,
    });
    if (entity.errors.length == 0) {
      parsed_without_errors += 1;
    }
  });
  return {
    parsed: parsed,
    results: parse_results,
    without_errors: parsed_without_errors,
  };
}

function proc_mset_parse_results(proc_mset_parsed) {
  var parse_results = [];
  proc_mset_parsed.forEach((entity, idx) => {
    parse_results.push({
      id: "proc_mset" + "|" + entity.proc_seq_nr + "-" + entity.mset_seq_nr,
      name: "Verfahren " + entity.proc_seq_nr + " -> TOM " + entity.mset_seq_nr,
      ok: true,
    });
  });
  return parse_results;
}

function prepare_procs_for_upload(parsed_procs, company_id, keep_seq_nr, max_seq_nr) {
  parsed_procs = parsed_procs.filter((e) => e.errors.length === 0);
  var proc_mset_links = [];
  var proc_seq_nr_map = {};
  parsed_procs.map((proc) => {
    max_seq_nr += 1;
    var new_seq_nr = keep_seq_nr ? proc.seq_nr : max_seq_nr;
    proc_seq_nr_map[proc.seq_nr] = new_seq_nr;
    proc.seq_nr = new_seq_nr;
    proc.processCompanyId = company_id;
    proc.warnings = undefined;
    proc.errors = undefined;
    if (proc.measureSets && proc.measureSets !== '[""]') {
      var mset_seq_nrs = JSON.parse(proc.measureSets);
      mset_seq_nrs.map((e) => {
        proc_mset_links.push({
          proc_seq_nr: proc.seq_nr,
          orig_mset_seq_nr: parseInt(e),
        });
      });
    }
    proc.measureSets = undefined;
  });
  return {
    parsed_procs: parsed_procs,
    proc_mset_links: proc_mset_links,
    proc_seq_nr_map: proc_seq_nr_map,
  };
}

function prepare_msets_for_upload(parsed_msets, company_id, keep_seq_nr, max_seq_nr, proc_mset_links) {
  parsed_msets = parsed_msets.filter((e) => e.errors.length === 0);
  var mset_seq_nr_map = {}; // orig to new
  parsed_msets.map((mset) => {
    max_seq_nr += 1;
    var new_seq_nr = keep_seq_nr ? mset.seq_nr : max_seq_nr;
    mset_seq_nr_map[mset.seq_nr] = new_seq_nr;
    mset.seq_nr = new_seq_nr;
    mset.measureSetCompanyId = company_id;
    mset.warnings = undefined;
    mset.errors = undefined;
  });
  // crashes if linked mset not imported.
  // make sure it IS imported.
  proc_mset_links.map((e) => {
    e.mset_seq_nr = mset_seq_nr_map[e.orig_mset_seq_nr];
  });
  return parsed_msets, mset_seq_nr_map;
}

function prepare_procmset_for_upload(proc_mset_links, uploaded_procs, uploaded_msets) {
  var procs_id_map = uploaded_procs.reduce((acc, cur) => {
    acc[cur.seq_nr] = cur.id;
    return acc;
  }, {});
  var msets_id_map = uploaded_msets.reduce((acc, cur) => {
    acc[cur.seq_nr] = cur.id;
    return acc;
  }, {});
  var procmsets = [];
  proc_mset_links.map((procmset_link) => {
    var procmset = {
      processMeasureSetProcessId: procs_id_map[procmset_link.proc_seq_nr],
      processMeasureSetMeasureSetId: msets_id_map[procmset_link.mset_seq_nr],
      status: "OPEN",
    };
    procmsets.push(procmset);
  });
  return procmsets;
}

function prepare_msetmeasures_for_upload(parsed_msetmeasures, uploaded_msets, mset_seq_nr_map) {
  var msets_id_map = uploaded_msets.reduce((acc, cur) => {
    acc[cur.seq_nr] = cur.id;
    return acc;
  }, {});
  parsed_msetmeasures = parsed_msetmeasures.filter((e) => e.errors.length === 0);
  parsed_msetmeasures.map((measure) => {
    measure.measureSetMeasureMeasureSetId = msets_id_map[mset_seq_nr_map[measure.measureSet]];
    measure.status = "OPEN";
    measure.warnings = undefined;
    measure.errors = undefined;
    measure.measureSet = undefined;
  });
  return parsed_msetmeasures;
}

function prepare_procmeasures_for_upload(parsed_procmeasures, uploaded_procs, proc_seq_nr_map) {
  var procs_id_map = uploaded_procs.reduce((acc, cur) => {
    acc[cur.seq_nr] = cur.id;
    return acc;
  }, {});
  parsed_procmeasures = parsed_procmeasures.filter((e) => e.errors.length === 0);
  parsed_procmeasures.map((measure) => {
    measure.processMeasureProcessId = procs_id_map[proc_seq_nr_map[measure.process]];
    measure.status = "OPEN";
    measure.warnings = undefined;
    measure.errors = undefined;
    measure.process = undefined;
  });
  return parsed_procmeasures;
}

function upload_data(graphql_mutation, graphql_api, stats, callback) {
  var data = stats.prepared;
  stats.numParsedWithoutErrors = data.length;
  stats.numUploadedWithoutErrors = 0;
  stats.numUploadErrors = 0;
  var responses = [];
  if (data.length === 0) {
    callback(responses);
  }
  data.forEach((e) => {
    var mutation = graphql_api.graphqlOperation(graphql_mutation, { input: e });
    graphql_api.API.graphql(mutation)
      .then((response) => {
        responses.push(response);
        stats.numUploadedWithoutErrors += 1;
        if (stats.numUploadedWithoutErrors + stats.numUploadErrors == stats.numParsedWithoutErrors) {
          callback(responses);
        }
      })
      .catch((err) => {
        stats.numUploadErrors += 1;
        console.error("error uploading:", err, e);
        if (stats.numUploadedWithoutErrors + stats.numUploadErrors == stats.numParsedWithoutErrors) {
          callback(responses);
        }
      });
  });
}

/*

This component serves two different purposes: 

- uploading data from a file
- creating data from a template

Technically, creating from template is very similar to uploading from file:
Both are parsed from an xlsx file format. The difference is that when uploading
the user provides the file, whereas when using a specific template the file is 
loaded from the backend S3 store. 

We can mount this component in one of two different modes. The component
behaves in slightly different ways depending on the mode. The mode depends
on where in the app the component is mounted, i.e. basically its route.

- Mode 1: Upload to existing company from xlsx
  route '/app/company/:cid/upload'
  from_template: false
  new_company: false
- Mode 2: Insert into existing company from template
  route '/app/company/:cid/template/:tid'
  from_template: true
  new_company: false

The xlsx file (both uploaded or template have same format) has several sheets:

- Verfahren (Processes)
- Allgemeine TOMs (MeasureSets)
- Einzelmaßnahmen (MeasureSetMeasures)
- ToDos (ProcessMeasures)
- Verknüpfungen (ProcessMeasureSets)

*/

function initUploadStats() {
  return {
    import: true,
    numParsedWithoutErrors: 0,
    numUploadedWithoutErrors: 0,
    numUploadErrors: 0,
    parsed: [],
    prepared: [],
    uploaded: [],
    uploadSuccess: false,
    uploadTotalFailure: false,
    uploadPartialFailure: false,
  };
}

function initData(context) {
  return {
    companyId: null, //context.$route.params.cid || context.cid,
    company: null,
    e1: 1,
    importSelection: [],
    parseResults: [],
    uploadSuccess: false,
    proc: initUploadStats(),
    mset: initUploadStats(),
    proc_mset: initUploadStats(),
    mset_measure: initUploadStats(),
    proc_measure: initUploadStats(),
    fileName: null,
    from_template: true,
    new_company: true,
    template_filename: null,
    template: {},
    parseExcelSuccess: false,
    keep_seq_nr: false,
    mset_seq_nr_map: null,
    proc_seq_nr_map: null,
    template_id: "minimal",
  };
}

const TEMPLATE_INFO = {
  minimal: {
    name: "Minimal",
    fname: "SODA_Vorlage_Minimal_v4.xlsx",
    description:
      "Eine minimale Verzeichnis-Vorlage zur Verdeutlichung des Prinzips hinter der Pflege eines Verzeichnis aller Verfahrenstätigkeiten mit Hilfe von SODA. Diese Vorlage sollte die Bedürfnisse der meisten Kleinstunternehmen bereits erfüllen.",
  },
  arzt: {
    name: "Arzt",
    fname: "SODA_Vorlage_Arzt_v3.xlsx",
    description:
      "Diese Verzeichnis-Vorlage wurde speziell auf die Bedürfnisse von Ärzten abgestimmt. Sie bildet die Basis für die Dokumentation der für eine Arztpraxis typischen Verfahren und Maßnahmen.",
  },
  verein: {
    name: "Vereine",
    fname: "SODA_Vorlage_Vereine_v5.xlsx",
    description:
      "Diese Verzeichnis-Vorlage wurde speziell auf die Bedürfnisse von Vereinen abgestimmt. Sie bildet die Basis für die Dokumentation der für einen Verein typischen Verfahren und Maßnahmen.",
  },
  stb: {
    name: "Steuerberater",
    fname: "SODA_Vorlage_StB_v5.xlsx",
    description: "Diese Verzeichnis-Vorlage wurde speziell auf die Bedürfnisse von Steuerberatern abgestimmt.",
  },
  allgemein: {
    name: "Allgemein",
    fname: "SODA_Vorlage_Allgemein_v8.xlsx",
    description:
      "Eine umfangreicher Verzeichnis-Vorlage für generische Bedürfnisse. Diese Verzeichnis-Vorlage berücksichtigt viele typische Szenarien zur Dokumentation der Verfahren und Maßnahmen bei KMUs.",
  },
  import: {
    name: "Import via Datei-Import",
    fname: "",
    description:
      "Ein umfangreicher Verzeichnis-Vorlage für generische Bedürfnisse. Diese Verzeichnis-Vorlage berücksichtigt viele typische Szenarien zur Dokumentation der Verfahren und Maßnahmen bei KMUs.",
  },
};

const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

export default {
  name: "ImportView",
  components: {
    SidebarToggleView,
  },
  props: {
    cid: String,
  },
  data: function() {
    return initData(this);
  },
  computed: {
    getCompanyQuery() {
      return this.$Amplify.graphqlOperation(getCompany, { id: this.companyId });
    },
    proc_max_seq_nr: {
      get() {
        return this.company && this.company.processes
          ? this.company.processes.reduce((a, e) => (a > e.seq_nr ? a : e.seq_nr), 0)
          : 0;
      },
    },
    mset_max_seq_nr: {
      get() {
        return this.company && this.company.measureSets
          ? this.company.measureSets.reduce((a, e) => (a > e.seq_nr ? a : e.seq_nr), 0)
          : 0;
      },
    },
    max_processes() {
      var user_info = this.$store.state.originalStore.user_info;
      if (!user_info) {
        return null;
      }
      var product_id = user_info.attributes["custom:active_product_id"];
      return products[product_id].usage.max_processes;
    },
    allowed_templates() {
      var user_info = this.$store.state.originalStore.user_info;
      if (!user_info) {
        return null;
      }
      var product_id = user_info.attributes["custom:active_product_id"];
      var templates = products[product_id].usage.allowed_templates;

      var add_templates = user_info.attributes["custom:add_templates"];
      if (add_templates && add_templates.length > 0) {
        add_templates = add_templates.split(",").map((e) => e.trim());
        templates = templates.concat(add_templates);
      }

      return templates;
    },
  },
  mounted() {
    this.from_template = !this.$route.path.split("/").includes("upload");
    if (this.from_template) {
      //this.template_id = this.$route.params.tid;
      this.template_filename = TEMPLATE_INFO[this.template_id].fname;
      this.template = TEMPLATE_INFO[this.template_id];
      this.getTemplate();
    }

    this.companyId = this.$route.params.cid;
    this.loadCompany();

    this.parseResults = [];
    this.resetUploadStats(this.proc);
    this.resetUploadStats(this.mset);
  },
  methods: {
    resetData() {
      if (!this.from_template) {
        this.$refs.excel.value = "";
        Object.assign(this.$data, initData(this));
      }
    },
    loadCompany() {
      this.loading = true;
      this.$Amplify.API.graphql(this.getCompanyQuery).then((response) => this.onLoadedCompany(response));
    },
    onLoadedCompany(response) {
      this.company = response.data.getCompany;
      this.company.processes = this.company.processes.items;
      this.company.measureSets = this.company.measureSets.items;
      this.loading = false;
    },
    cancelSuccess() {
      this.resetData();
      this.$router.push({ path: "/app/company/" + this.companyId + "/processes" });
      this.$emit("import-success");
    },
    cancelFailed() {
      this.resetData();
      this.$router.push({ path: "/app/company/" + this.companyId });
      this.$emit("import-failed");
    },
    cancel() {
      this.resetData();
      this.$router.push({ path: "/app/company/" + this.companyId });
      this.$emit("import-cancel");
    },
    onNext() {
      this.e1 = 2;
    },
    pickFile() {
      this.$refs.excel.click();
    },
    onFilePicked(e) {
      this.clearTemplate();
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf(".") <= 0) {
          return;
        }
        this.fileName = files[0].name;
        const reader = new FileReader();
        reader.readAsArrayBuffer(files[0]);
        reader.onload = (e) => {
          var uint8buf = new Uint8Array(e.target.result);
          return this.parseExcelData(uint8buf);
        };
      } else {
        // show alert: "Datei nicht gefunden. Bitte nochmals versuchen."
      }
    },
    parseExcelData(data) {
      var wb = XLSX.read(data, { type: "array" });
      if (wb.SheetNames.includes("Verfahren")) {
        var raw_procs = XLSX.utils.sheet_to_json(wb.Sheets["Verfahren"]);
        var parsed = parse_raw(raw_procs, process_fields_mapping, ["seq_nr", "text_header"], "proc");
        this.proc.parsed = parsed.parsed;
        this.parseResults.push({
          id: "proc",
          name: parsed.results.length + " Verfahren",
          children: parsed.results,
        });
        this.proc.numParsedWithoutErrors += parsed.without_errors;
      }
      this.prepareProcesses();

      if (wb.SheetNames.includes("ToDos")) {
        var raw_measures = XLSX.utils.sheet_to_json(wb.Sheets["ToDos"]);
        var parsed = parse_raw(raw_measures, procmeasure_fields_mapping, ["process", "label"], "proc_measure");
        this.proc_measure.parsed = parsed.parsed;
        this.parseResults.push({
          id: "proc_measure",
          name: parsed.results.length + " ToDos",
          children: parsed.results,
        });
        this.proc_measure.numParsedWithoutErrors += parsed.without_errors;
      }

      if (wb.SheetNames.includes("Allgemeine TOMs")) {
        var raw_msets = XLSX.utils.sheet_to_json(wb.Sheets["Allgemeine TOMs"]);
        var parsed = parse_raw(raw_msets, measureset_fields_mapping, ["seq_nr", "type"], "mset");
        this.mset.parsed = parsed.parsed;
        this.parseResults.push({
          id: "mset",
          name: parsed.results.length + " Allgemeine TOMs",
          children: parsed.results,
        });
        this.mset.numParsedWithoutErrors += parsed.without_errors;
      }
      this.prepareMeasureSets();

      // after measuresets are prepared, we can display the proc_mset parseResults
      this.proc_mset.numParsedWithoutErrors = this.proc_mset.parsed.length;
      var parse_results = proc_mset_parse_results(this.proc_mset.parsed);
      this.parseResults.push({
        id: "proc_mset",
        name: parse_results.length + " Verknüpfungen",
        children: parse_results,
      });

      if (wb.SheetNames.includes("Einzelmaßnahmen")) {
        var raw_measures = XLSX.utils.sheet_to_json(wb.Sheets["Einzelmaßnahmen"]);
        var parsed = parse_raw(raw_measures, msetmeasure_fields_mapping, ["measureSet", "label"], "mset_measure");
        this.mset_measure.parsed = parsed.parsed;
        this.parseResults.push({
          id: "mset_measure",
          name: parsed.results.length + " Einzelmaßnahmen",
          children: parsed.results,
        });
        this.mset_measure.numParsedWithoutErrors += parsed.without_errors;
      }
      this.parseExcelSuccess = true;
    },
    getTemplate() {
      this.$Amplify.Storage.get("templates/" + this.template_filename, {
        level: "public",
      })
        .then((result) => {
          util.httpGetData(result, (uint8buf) => {
            this.parseExcelData(uint8buf);
          });
        })
        .catch((err) => console.error("get err", err));
    },
    resetUploadStats(stats) {
      stats.import = true;
      stats.numParsedWithoutErrors = 0;
      stats.numUploadedWithoutErrors = 0;
      stats.numUploadErrors = 0;
      stats.uploadSuccess = false;
      stats.uploadTotalFailure = false;
      stats.uploadPartialFailure = false;
      stats.prepared = [];
      stats.parsed = [];
      stats.uploaded = [];
    },
    updateUploadMessages(stats) {
      if (stats.numUploadErrors == 0) {
        stats.uploadSuccess = true;
      } else if (stats.numUploadedWithoutErrors == 0) {
        stats.uploadTotalFailure = true;
      } else {
        stats.uploadPartialFailure = true;
      }
    },
    upload_allowed() {
      // Check template restriction
      if (this.template_id && this.template_id != "import") {
        if (!this.allowed_templates.includes(this.template_id)) {
          return false;
        }
        // Check number processes restrictions (only if using template)
        if (this.company.processes.length + this.proc.parsed.length > this.max_processes) {
          return false;
        }
      } else {
        // Upload from file is unrestricted on purpose
      }
      return true;
    },
    upload() {
      if (this.upload_allowed()) {
        this.e1 = 3;
        this.uploadProcesses();
      } else {
        this.$eventHub.emit("show-template-upload-disallowed", this.company.processes.length);
      }
    },
    prepareProcesses() {
      var procImportNames = this.importSelection
        .filter((e) => (e.split("|").length == 2) & (e.split("|")[0] == "proc"))
        .map((e) => e.split("|")[1]);
      var processes = this.proc.parsed;
      var res = prepare_procs_for_upload(processes, this.companyId, this.keep_seq_nr, this.proc_max_seq_nr);
      processes = res.parsed_procs;
      this.proc_mset.parsed = res.proc_mset_links;
      this.proc_seq_nr_map = res.proc_seq_nr_map;
      processes.forEach((e) => this.proc.prepared.push(e));
    },
    uploadProcesses() {
      upload_data(createProcess, this.$Amplify, this.proc, this.processesUploadFinished);
    },
    processesUploadFinished(responses) {
      this.proc.uploaded = responses.map((e) => e.data.createProcess);
      this.proc.prepared.forEach((e) => {
        this.$recordCreate(this.companyId, "PROCESS", e, (res, err) => {
          res ? console.log("logged PROCESS create", res) : console.error("error logging PROCESS create", err, e);
        });
      });
      this.updateUploadMessages(this.proc);
      this.prepareProcessMeasures();
      this.uploadMeasureSets();
    },
    prepareMeasureSets() {
      var msetImportNames = this.importSelection
        .filter((e) => (e.split("|").length == 2) & (e.split("|")[0] == "mset"))
        .map((e) => e.split("|")[1]);
      var measureSets = this.mset.parsed; //.filter(e => msetImportNames.includes(e.type))
      measureSets,
        (this.mset_seq_nr_map = prepare_msets_for_upload(
          measureSets,
          this.companyId,
          this.keep_seq_nr,
          this.mset_max_seq_nr,
          this.proc_mset.parsed
        ));
      measureSets.forEach((e) => this.mset.prepared.push(e));
      //console.log('prepareMeasureSets', this.mset.prepared, this.mset_seq_nr_map)
    },
    uploadMeasureSets() {
      upload_data(createMeasureSet, this.$Amplify, this.mset, this.measureSetsUploadFinished);
    },
    measureSetsUploadFinished(responses) {
      this.mset.uploaded = responses.map((e) => e.data.createMeasureSet);
      this.mset.prepared.forEach((e) => {
        this.$recordCreate(this.companyId, "MEASURESET", e, (res, err) => {
          res ? console.log("logged MEASURESET create", res) : console.error("error logging MEASURESET create", err, e);
        });
      });
      this.updateUploadMessages(this.mset);
      // links and measures can be prepared after upload for procs and msets finished only (we need the ids)
      this.prepareProcessMeasureSets();
      this.prepareMeasureSetMeasures();
      this.uploadProcessMeasureSets();
    },
    prepareProcessMeasureSets() {
      var processMeasureSets = this.proc_mset.parsed;
      processMeasureSets = prepare_procmset_for_upload(processMeasureSets, this.proc.uploaded, this.mset.uploaded);
      processMeasureSets.forEach((e) => this.proc_mset.prepared.push(e));
    },
    uploadProcessMeasureSets() {
      upload_data(createProcessMeasureSet, this.$Amplify, this.proc_mset, this.processMeasureSetsUploadFinished);
    },
    processMeasureSetsUploadFinished() {
      this.proc_mset.prepared.forEach((e) => {
        this.$recordCreate(this.companyId, "PROCESSMEASURESET", e, (res, err) => {
          res
            ? console.log("logged PROCESSMEASURESET create", res)
            : console.error("error logging PROCESSMEASURESET create", err, e);
        });
      });
      this.updateUploadMessages(this.proc_mset);
      this.uploadProcessMeasures();
    },
    prepareProcessMeasures() {
      var processMeasures = this.proc_measure.parsed;
      processMeasures = prepare_procmeasures_for_upload(processMeasures, this.proc.uploaded, this.proc_seq_nr_map);
      processMeasures.forEach((e) => this.proc_measure.prepared.push(e));
    },
    uploadProcessMeasures() {
      upload_data(createProcessMeasure, this.$Amplify, this.proc_measure, this.processMeasuresUploadFinished);
    },
    processMeasuresUploadFinished() {
      this.proc_measure.prepared.forEach((e) => {
        this.$recordCreate(this.companyId, "PROCESSMEASURE", e, (res, err) => {
          res
            ? console.log("logged PROCESSMEASURE create", res)
            : console.error("error logging PROCESSMEASURE create", err, e);
        });
      });
      this.updateUploadMessages(this.proc_measure);
      this.uploadMeasureSetMeasures();
    },
    prepareMeasureSetMeasures() {
      var measureSetMeasures = this.mset_measure.parsed;
      measureSetMeasures = prepare_msetmeasures_for_upload(
        measureSetMeasures,
        this.mset.uploaded,
        this.mset_seq_nr_map
      );
      measureSetMeasures.forEach((e) => this.mset_measure.prepared.push(e));
    },
    uploadMeasureSetMeasures() {
      upload_data(createMeasureSetMeasure, this.$Amplify, this.mset_measure, this.measureSetMeasuresUploadFinished);
    },
    measureSetMeasuresUploadFinished() {
      this.mset_measure.prepared.forEach((e) => {
        this.$recordCreate(this.companyId, "MEASURESETMEASURE", e, (res, err) => {
          res
            ? console.log("logged MEASURESETMEASURE create", res)
            : console.error("error logging MEASURESETMEASURE create", err, e);
        });
      });
      this.updateUploadMessages(this.mset_measure);
      this.uploadFinished();
    },
    uploadFinished() {
      this.uploadSuccess =
        (this.proc.import === this.proc.uploadSuccess) &
        (this.mset.import === this.mset.uploadSuccess) &
        (this.proc_mset.import === this.proc_mset.uploadSuccess) &
        (this.mset_measure.import === this.mset_measure.uploadSuccess) &
        (this.proc_measure.import === this.proc_measure.uploadSuccess);
    },
    setTemplateId(type) {
      this.template_id = type;
      this.template = TEMPLATE_INFO[this.template_id];
      this.template_filename = TEMPLATE_INFO[this.template_id].fname;
      this.clearTemplate();
      if (type != "import") {
        this.getTemplate();
      }
    },
    can_create_from_template(tpl_name) {
      return this.allowed_templates.includes(tpl_name);
    },
    templateIsImport() {
      return this.template_id === "import";
    },
    forwardToPurchase() {
      this.$router.push({ path: "/home/plans" });
    },
    clearTemplate() {
      (this.fileName = null),
        (this.parseExcelSuccess = false),
        (this.mset_seq_nr_map = null),
        (this.proc_seq_nr_map = null),
        (this.proc = initUploadStats()),
        (this.mset = initUploadStats()),
        (this.proc_mset = initUploadStats()),
        (this.mset_measure = initUploadStats()),
        (this.proc_measure = initUploadStats()),
        (this.parseResults = []);
      this.resetUploadStats(this.proc);
      this.resetUploadStats(this.mset);
      this.resetData();
    },
  },
};
</script>

<style lang="scss" scoped></style>
